// @generated by TypeGen from LogbookApi/UserApi.swift - DO NOT EDIT

import { IShipUserLevel } from "../LogbookModel/ShipUser"
import type { IShipUserCrewRole, IShipUserResponse } from "../LogbookModel/ShipUser"
import type { IAccountInvitationResponse } from "../LogbookServer/AccountApi"
import type { ISuccessResponse } from "../LogbookServer/SuccessResponse"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface IShipUserRequest {
  active?: number;
  email?: string;
  name?: string;
  shortname?: string;
  shipUserCrewRole?: IShipUserCrewRole;
  shipUserLevel?: IShipUserLevel;
  language?: string;
}

export interface IUserInviteResponse {
  userId: number;
}

export interface UserApiEndpoints {
  "DELETE /api/ships/:shipId/users/:userId": {
    params: { shipId: number; userId: number };
    query: {};
    request: never;
    response: ISuccessResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/invitation/:token": {
    params: { token: string };
    query: {};
    request: never;
    response: IAccountInvitationResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "POST /api/ships/:shipId/users": {
    params: { shipId: number };
    query: {};
    request: IShipUserRequest;
    response: IShipUserResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ships/invitation/:token": {
    params: { token: string };
    query: {};
    request: never;
    response: IShipUserResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "PUT /api/ships/:shipId/users/:userId": {
    params: { shipId: number; userId: number };
    query: {};
    request: IShipUserRequest;
    response: IShipUserResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const userApiEndpoints = {
  "DELETE /api/ships/:shipId/users/:userId": { targets: ["server"], permission: { ship: IShipUserLevel.primary } },
  "GET /api/ships/invitation/:token": { targets: ["server"], permission: {} },
  "POST /api/ships/:shipId/users": { targets: ["app", "server"], permission: { ship: IShipUserLevel.primary } },
  "POST /api/ships/invitation/:token": { targets: ["server"], permission: { session: true } },
  "PUT /api/ships/:shipId/users/:userId": { targets: ["app", "server"], permission: { ship: IShipUserLevel.primary } },
} as const;

export class UserApi {
  constructor(private client: ApiClient) {}

  shipUsers = {
    delete: (a: ApiArgs<UserApiEndpoints, "DELETE /api/ships/:shipId/users/:userId">) => ({
      call: (): Promise<ISuccessResponse> => {
        assertTarget(this.client, "DELETE /api/ships/:shipId/users/:userId", userApiEndpoints["DELETE /api/ships/:shipId/users/:userId"].targets);
        return this.client.call<ISuccessResponse>("DELETE /api/ships/:shipId/users/:userId", a);
      },
      url: (): string => this.client.url("DELETE /api/ships/:shipId/users/:userId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
    invitation: (a: ApiArgs<UserApiEndpoints, "GET /api/ships/invitation/:token">) => ({
      call: (): Promise<IAccountInvitationResponse> => {
        assertTarget(this.client, "GET /api/ships/invitation/:token", userApiEndpoints["GET /api/ships/invitation/:token"].targets);
        return this.client.call<IAccountInvitationResponse>("GET /api/ships/invitation/:token", a);
      },
      url: (): string => this.client.url("GET /api/ships/invitation/:token", a),
      available: (_user?: ApiUser): boolean => true,
    }),
    create: (a: ApiArgs<UserApiEndpoints, "POST /api/ships/:shipId/users">) => ({
      call: (): Promise<IShipUserResponse> => {
        assertTarget(this.client, "POST /api/ships/:shipId/users", userApiEndpoints["POST /api/ships/:shipId/users"].targets);
        return this.client.call<IShipUserResponse>("POST /api/ships/:shipId/users", a);
      },
      url: (): string => this.client.url("POST /api/ships/:shipId/users", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
    acceptInvitation: (a: ApiArgs<UserApiEndpoints, "POST /api/ships/invitation/:token">) => ({
      call: (): Promise<IShipUserResponse> => {
        assertTarget(this.client, "POST /api/ships/invitation/:token", userApiEndpoints["POST /api/ships/invitation/:token"].targets);
        return this.client.call<IShipUserResponse>("POST /api/ships/invitation/:token", a);
      },
      url: (): string => this.client.url("POST /api/ships/invitation/:token", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    update: (a: ApiArgs<UserApiEndpoints, "PUT /api/ships/:shipId/users/:userId">) => ({
      call: (): Promise<IShipUserResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/users/:userId", userApiEndpoints["PUT /api/ships/:shipId/users/:userId"].targets);
        return this.client.call<IShipUserResponse>("PUT /api/ships/:shipId/users/:userId", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/users/:userId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.primary,
    }),
  };
}
